// extracted by mini-css-extract-plugin
export default {"header":"header-mobile_header__1ufT-"};